import { Link } from "react-router-dom";
import { MapPin, Gift, Crosshair } from "lucide-react";
import { CATEGORY_ICONS, CATEGORY_LABELS } from "@/lib/categories";

export default function DiscountCard({ discount, index = 0 }) {
    const Icon = CATEGORY_ICONS[discount.category] || Crosshair;
    return (
        <Link
            to={`/discount/${discount.id}`}
            data-testid={`discount-card-${discount.id}`}
            className="tactical-card p-5 flex flex-col gap-3 group fade-up"
            style={{ animationDelay: `${index * 0.04}s` }}
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 border border-white/15 flex items-center justify-center group-hover:border-volt/60">
                        <Icon className="w-4 h-4 text-volt" />
                    </div>
                    <span className="mono-label text-[10px]">
                        {CATEGORY_LABELS[discount.category] || discount.category}
                    </span>
                </div>
                {discount.is_freebie && (
                    <div className="flex items-center gap-1 px-2 py-1 bg-volt/10 border border-volt/40">
                        <Gift className="w-3 h-3 text-volt" />
                        <span className="mono-label text-volt text-[9px]">FREE</span>
                    </div>
                )}
            </div>

            <div>
                <div className="mono-label text-[10px] text-[#94a3b8] mb-1">
                    {discount.business_name}
                </div>
                <h3 className="font-oswald text-xl uppercase tracking-wide text-white group-hover:text-volt leading-tight">
                    {discount.title}
                </h3>
            </div>

            <div className="text-sm text-[#94a3b8] line-clamp-2 flex-1">
                {discount.discount_details}
            </div>

            <div className="flex items-center justify-between pt-3 border-t border-white/5">
                <div className="flex items-center gap-1 text-xs text-[#94a3b8]">
                    <MapPin className="w-3 h-3 text-volt" />
                    <span>{discount.city}, {discount.state}</span>
                </div>
                {discount.distance_miles != null && (
                    <span className="mono-label text-volt text-[10px]">
                        {discount.distance_miles} MI
                    </span>
                )}
            </div>
        </Link>
    );
}
